import { endOfDay, isAfter, isBefore, subDays } from 'date-fns'
import { toDate } from 'util/date/formatDate'

const MEDICAO_DATA_ANTERIOR_ATENDIMENTO = 'A data da medição deve ser anterior à data do atendimento.'
const MEDICAO_DATA_POSTERIOR_NASCIMENTO = 'A data da medição deve ser posterior à data de nascimento do cidadão.'

export function validateDataMedicaoAnterior(
  dataMedicaoAnterior: LocalDate,
  dataAtendimento: Instant,
  dataNascimentoCidadao: LocalDate
): string | null {
  if (!dataMedicaoAnterior) {
    return null
  }

  const computedDate = toDate(dataMedicaoAnterior)
  const computedDataAtendimento = subDays(toDate(dataAtendimento), 1)
  const computedDataNascimento = endOfDay(subDays(toDate(dataNascimentoCidadao), 1))

  if (isBefore(computedDataAtendimento, computedDate)) {
    return MEDICAO_DATA_ANTERIOR_ATENDIMENTO
  }

  if (isAfter(computedDataNascimento, computedDate)) {
    return MEDICAO_DATA_POSTERIOR_NASCIMENTO
  }

  return null
}
